import React, { useEffect } from 'react';
import styled from 'styled-components';
import Sound from 'react-sound';
import UIFx from 'uifx';
import { getVideoUrl } from '../../utils/image';
import { useImagesContext } from '../../contexts/ImagesContext';
import { ImgClick } from '../utility';
import { connect } from 'react-redux';
import { resetPowerSearch, setPowerSearch } from '../../actions/learn-fight';
import { setPassWanderlandStage } from '../../services/wanderland';
import { errorMessage } from '../../utils/messageUtil';
import gotChestSound from './sounds/got-chest.mp3';
import yardnaphaRunOffSound from './sounds/yardnapha-run-off.mp3';
import wrongAnswerFile from './sounds/wrong-answer.mp3';

const wrongAnswerSound = new UIFx(wrongAnswerFile);

const VIDEO_FORWARD_SECONDS = 20;

const WanderlandStageVideo = ({
  student,
  stage,
  handleBack,
  searchPower,
  setPowerSearch,
  handleCompleted,
  resetPowerSearch,
  config,
}) => {
  const { images } = useImagesContext();
  const [issueYardnapha, setIssueYardnapha] = React.useState(null);
  const [topLiftClick, setTopLiftClick] = React.useState(false);
  const [isPlay, setIsPlay] = React.useState(true);
  const videoRef = React.useRef(null);

  // console.debug(
  //   'WanderlandStageVideo.videoUrl',
  //   `${getVideoUrl(`api/wanderland-videos/${stage.video}`)}`
  // );

  useEffect(() => {
    console.debug('WanderlandStageVideo.useEffect');
    console.debug('searchPower', searchPower);
    console.debug('stage', stage);
    if (searchPower === null) {
      console.debug('searchPower is null');
      resetPowerSearch(stage.searchPower);
    }
  }, [stage]);

  function handleTopLeftClick() {
    setTopLiftClick(true);
    setTimeout(() => {
      setTopLiftClick(false);
    }, 3000);
  }

  function handleTopLeftDbClick() {
    console.debug('handleTopLeftDbClick');
    console.debug('searchPower', searchPower);
    if (!config.isMutedSound) {
      wrongAnswerSound.play();
    }
    setPowerSearch(searchPower - 1);
    if (searchPower - 1 <= 0) {
      videoRef.current.pause();
      setTimeout(() => {
        handleBack();
      }, 3000);
    }
  }

  function handlePauseOrPlay() {
    setIsPlay(!isPlay);
    if (isPlay === true) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
  }

  function handleYardnaphaClick() {
    console.debug('handleYardnaphaClick');
    if (topLiftClick) {
      setIssueYardnapha(-1);
      setTimeout(() => {
        // setIssueYardnapha(stage.issueYardnapha);
        setPassWanderlandStage(student.id, stage.id)
          .then((resp) => {
            const { data } = resp;
            console.debug('setPassWanderlandStage', data);
            resetPowerSearch(null);
            handleCompleted(data.issueYardnapha, data.issuePoint);
          })
          .catch((error) => {
            errorMessage(error);
          });
      }, 1500);
    }
  }

  function handleMyBack() {
    handleBack();
  }

  // console.debug('searchPower', searchPower);
  function handleSkipVideo() {
    const video = videoRef.current;
    video.currentTime = Math.min(
      video.duration,
      video.currentTime + VIDEO_FORWARD_SECONDS,
    );
  }

  return (
    <Container>
      <video
        id="videoPlayer"
        // width='100%'
        // height='100%'
        autoplay="autoplay"
        width="1920"
        height="1080"
        // controls
        // controlsList='nodownload'
        // muted="muted"
        ref={videoRef}
      >
        <source
          src={`${getVideoUrl(`/api/v2/wanderland-videos/${stage.video}`)}`}
          type="video/mp4"
        />
      </video>
      {!stage.isPass && (
        <>
          {searchPower > 0 ? (
            <YardNaPa src={images['video-yardnapha-on.png']} />
          ) : (
            <YardNaPa src={images['video-yardnapha-off.png']} />
          )}
          <HiddenTopLeftButton
            onClick={handleTopLeftClick}
            onDoubleClick={handleTopLeftDbClick}
          ></HiddenTopLeftButton>
          <HiddenYardnaphaButton
            onClick={handleYardnaphaClick}
          ></HiddenYardnaphaButton>
          <PowerBlock>
            {Array.from(Array(searchPower).keys()).map((_) => (
              <img src={images['video-power-searching.png']} alt="" />
            ))}
          </PowerBlock>
        </>
      )}
      {issueYardnapha === -1 && (
        <Sound
          url={gotChestSound}
          playStatus="PLAYING"
          loop={false}
          volume={config.isMutedSound ? 0 : 100}
        ></Sound>
      )}
      <YardNaPa
        src={issueYardnapha === -1 ? images[`video-yardnapha-issue.png`] : null}
      />
      <HiddenTopRightButton onClick={handlePauseOrPlay}></HiddenTopRightButton>
      <Back src={images['back.png']} onClick={handleMyBack} alt="" />
      {searchPower === 0 && (
        <Sound
          url={yardnaphaRunOffSound}
          playStatus="PLAYING"
          loop={false}
          volume={config.isMutedSound ? 0 : 100}
        ></Sound>
      )}
      <YardnaphaRunoffDialog
        src={searchPower === 0 ? images['video-yardnapha-runoff.png'] : null}
      />
      <SkipVideoButton onDoubleClick={handleSkipVideo} />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 1920px;
  height: 1080px;
  // padding: 0;
  // margin: 0;
  overflow: hidden;
`;

const Back = styled(ImgClick)`
  position: absolute;
  bottom: 24px;
  left: 20px;
`;

const PowerBlock = styled.div`
  position: absolute;
  bottom: 16px;
  left: 110px;
  display: flex;
`;

const YardNaPa = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
`;

const HiddenTopLeftButton = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 250px;
  height: 250px;
  // border: 1px solid red;
`;

const HiddenTopRightButton = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 250px;
  height: 250px;
  // border: 1px solid red;
`;

const HiddenYardnaphaButton = styled.div`
  position: absolute;
  top: 450px;
  left: 300px;
  width: 250px;
  height: 250px;
  // border: 1px solid red;
`;

const YardnaphaRunoffDialog = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const SkipVideoButton = styled.div`
  position: absolute;
  width: 250px;
  height: 250px;
  bottom: 0px;
  right: 0px;
  // border: 1px solid blue;
`;

const mapStateToProps = ({ student, learnFight, config }) => ({
  student,
  searchPower: learnFight.searchPower,
  config,
});

const mapDispatchToProps = {
  setPowerSearch,
  resetPowerSearch,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WanderlandStageVideo);
